﻿//header section
gsap.set(".aboutPageHeader .lottieContainer", { autoAlpha: 1 });
gsap.from(".aboutPageHeader .lottieContainer", { opacity: 0, y: 30, stagger: 0.2 });

//Why Work with us section
gsap.set('.paperBulbContainer', {autoAlpha:1})
gsap.from('.lightBulbImg', {
    opacity: 0, xPercent: 30, scrollTrigger: {
        trigger: '.paperBulbContainer',
        start: 'top center',
    }
});

//Why you need us section
gsap.set('.byYourSidePerkContainer', { autoAlpha: 1 });
gsap.from('.byYourSidePerkContainer', {
    opacity: 0,
    y: -30,
    stagger: 0.2,
    scrollTrigger: {
        trigger: '.whyYouNeedUsContainer',
        start: 'top center'
    }
});

//Awards section
gsap.from(".awardCard", {
    opacity: 0,
    yPercent: 30,
    stagger: 0.14,
    scrollTrigger: {
        trigger: ".mainAwardsContainer",
        start: "top 65%"
    }
});

//Diversity section
gsap.from('.diversityList li', {
    xPercent: 30,
    opacity: 0,
    stagger: .2,
    scrollTrigger: {
        trigger: '.weBelieveHeader',
        start: 'top 80%'
    }
});

//uspark section
gsap.from('.uSparkImage', {
    yPercent: 30,
    opacity: 0,
    scrollTrigger: {
        trigger: '.uSparkSection',
        start: 'top center'
    }
});

//Our People section
gsap.from('.gallery-img', {
    opacity: 0, stagger: 0.1, scrollTrigger: {
        trigger: '.albumContainerColumn',
        start: 'top center',
        end: 'top 60%'
    }
});